import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableRoleGroups from './libraries';

export const PageRoleGroupsComponent = (props: any) => {
    const title = 'Role Groups';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/user/role-groups">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableRoleGroups />
        </LayoutCMS>
    );
};

export default PageRoleGroupsComponent;



// WEBPACK FOOTER //
// ./src/pages/role-groups/component.tsx